import { IEntity, LiteralObject } from 'viggo-sistemas-core-web';

import { IPreCadastro } from '@app/modules/cliente/models/pre_cadastro.model';
import { IParceiro } from '@app/modules/parceiro/model';

export enum TIPO_VENDEDOR {
  INTERNO = 'INTERNO',
  EXTERNO = 'EXTERNO'
}

export interface ICarteira {
  vendedor_id: string;
  pre_cadastro_id: string;
  pre_cadastro?: IPreCadastro;
}

export interface IVendedorTPF {
  vendedor_id: string;
  tabela_preco_fabrica_id: string;
  tabela_preco_fabrica?: IPreCadastro;
}

export interface IVendedor extends IEntity {
  codigo: number;
  parceiro: IParceiro;
  domain_id: string;
  carteira: ICarteira[];
  tabelas_preco_fabrica: IVendedorTPF[];
  settings: LiteralObject;
  tipo: TIPO_VENDEDOR;
  saldo_credito: number;
}
